import { render, staticRenderFns } from "./riLifeCycle.vue?vue&type=template&id=6abbfcb6&scoped=true&"
import script from "./riLifeCycle.vue?vue&type=script&lang=js&"
export * from "./riLifeCycle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abbfcb6",
  null
  
)

export default component.exports